<div fxLayout="column" fxLayoutAlign="space-around center" class="error_div">
  <img *ngIf="is404" src="assets/img/error/img_error404.png" alt="error404" />
  <img *ngIf="!is404" src="assets/img/error/img_error403.png" alt="error403" />
  <h1 *ngIf="is404" translate>error.error404</h1>
  <h4 translate>{{ is404 ? 'error.pagina_404' : 'error.pagina_403' }}</h4>
  <p translate>{{ is404 ? 'error.parrafo_404_1' : 'error.parrafo_403_1' }}</p>
  <p translate>{{ is404 ? 'error.parrafo_404_2' : 'error.parrafo_403_2' }}</p>
</div>
